import { render, staticRenderFns } from "./MyWallet.vue?vue&type=template&id=b29d3c12&scoped=true&"
import script from "./MyWallet.vue?vue&type=script&lang=js&"
export * from "./MyWallet.vue?vue&type=script&lang=js&"
import style0 from "./MyWallet.vue?vue&type=style&index=0&id=b29d3c12&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b29d3c12",
  null
  
)

export default component.exports